// extracted by mini-css-extract-plugin
export default {"fullWidth":"eo-z","image":"fo-z","lazyLoadPicture":"go-z","lazyLoadSpinner":"ho-z","lazyLoadSpin":"io-z","lazyLoadImage":"jo-z","hasStyledAspectRatio":"ko-z"};